import {compact} from 'lodash';

import {
  computeIsValidCellActivityDraftSummary,
  findMostRecentCellActivity,
  ValidCellActivityDraftSummaryOptions,
  VisualCellActivityTypesEnum,
} from '../../../../../../libs/inboxes/business/src/cells/cellActivity';
import {MessageModel} from '../../../../../../libs/shared/core/src/models/api/messageModel';
import {computeCommentDraftHasDisplayableContent} from '../../../../../helpers/models/draftCommentHelpers';
import {DraftSummaryModel} from '../../../../../models/api/draftSummaryModel';
import {
  CommentDraftSummary,
  LastCommentDraftModel,
  LastCommentModel,
} from '../../../../../store/data/conversations/conversationCellSelectors';

interface FindMostRecentActivityForCellOptions {
  isInDraftsFolder: boolean;
  /** User ID or delegated teammate ID. */
  teammateId: number;
  lastManualMessage: MessageModel | undefined;
  lastComment: LastCommentModel | undefined;
  lastCommentDraft: LastCommentDraftModel | undefined;
  draft: DraftSummaryModel | undefined;
  commentDraftSummary: CommentDraftSummary | undefined;
}

export function findMostRecentActivityForCell(props: FindMostRecentActivityForCellOptions) {
  const {
    isInDraftsFolder,
    teammateId,
    lastManualMessage,
    lastComment,
    draft,
    lastCommentDraft,
    commentDraftSummary,
  } = props;
  const draftOptions: ValidCellActivityDraftSummaryOptions = {
    isInDraftsFolder,
    teammateId,
  };

  return findMostRecentCellActivity(
    compact([
      // Last message that is not an auto-responder.
      lastManualMessage && {
        type: VisualCellActivityTypesEnum.TIMELINE_MESSAGE,
        message: lastManualMessage,
        date: lastManualMessage.sentAt,
      },
      // Last comment.
      lastComment && {
        type: VisualCellActivityTypesEnum.TIMELINE_COMMENT,
        ...lastComment,
        date: lastComment.comment.sentAt,
      },
      // Message draft.
      draft &&
        computeIsValidCellActivityDraftSummary(draft, draftOptions) && {
          type: VisualCellActivityTypesEnum.DRAFT_MESSAGE,
          draft,
          // Err on the side of showing drafts with a missing updatedAt.
          date: draft.updatedAt || Infinity,
        },
      // Comment draft when we have the actual comment.
      // TODO: Handle the comment summary and full comment cases in an upstream component.
      lastCommentDraft &&
        computeCommentDraftHasDisplayableContent(lastCommentDraft.comment) && {
          type: VisualCellActivityTypesEnum.DRAFT_COMMENT,
          author: lastCommentDraft.author,
          draft: lastCommentDraft.comment,
          // Err on the side of showing drafts with a missing updatedAt.
          date: lastCommentDraft.comment.updatedAt || Infinity,
        },
      // Comment draft when we only have the summary.
      commentDraftSummary &&
        computeIsValidCellActivityDraftSummary(commentDraftSummary.summary, draftOptions) && {
          type: VisualCellActivityTypesEnum.DRAFT_COMMENT,
          author: commentDraftSummary.author,
          draft: commentDraftSummary.summary,
          // Err on the side of showing drafts with a missing updatedAt.
          date: commentDraftSummary.summary.updatedAt || Infinity,
        },
    ]),
  );
}
